export const TEXT = 'text';
export const NUMBER = 'number';
export const DATE = 'date';
export const MULTI_SELECT = 'multi-select';
export const SELECT = 'select';
